export enum Region {
	US = 'US',
	CA = 'CA',
	LATAM = 'LATAM'
}


// WEBPACK FOOTER //
// ./js/PFF/angular-modules/common/interfaces/Region.ts